import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Box } from '@material-ui/core';

const BopsAddress = ({ address, searchPage, classes }) => {
  return (
    <Box data-testid="bops-address-box" className={searchPage ? classes.addressContainer : null}>
      <Typography
        data-testid={searchPage ? 'address-bold' : 'address-fullName'}
        className={searchPage ? classes.searchTitle : classes.checkoutTitle}
      >
        {address.firstName?.toLowerCase()} {address.lastName}
      </Typography>
      <Typography variant="body1" className={classes.addressText} color="textSecondary" data-testid="address-line1">
        {address.line1}
      </Typography>
      <Typography variant="body1" className={classes.addressText} color="textSecondary" data-testid="address-line2">
        {address.line2}
      </Typography>
      <Typography variant="body1" className={classes.addressText} color="textSecondary" data-testid="address-full-line">
        {`${address.city}, ${address.state} ${address.country} ${address.zip}`}
      </Typography>
    </Box>
  );
};

BopsAddress.propTypes = {
  classes: PropTypes.shape({}),
  address: PropTypes.shape({}),
  searchPage: PropTypes.bool,
};

BopsAddress.defaultProps = {
  address: {},
  searchPage: false,
  classes: {},
};

export default BopsAddress;
